// Core React
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Node Libs
import axios from 'axios';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import Signup from './views/SignUp';
import Login from './views/Login';
import SignOff from './views/SignOff';
import MyAccount from './views/MyAccount';
import AddPet from './views/AddPet';
import VetchatText from './views/VetchatText';
import VetchatVideo from './views/VetchatVideo';
import Home from './views/Home';
import ForgotPassword from './views/ForgotPassword';
import ResetPassword from './views/ResetPassword';
// import Admin from "./views/Admin";
import NotFound from './components/pages/NotFound';

import HowItWorksPage from './views/pages/how-it-works';
import PricingPage from './views/pages/pricing';
import AboutPage from './views/pages/about';
import GeneralPage from './views/pages/general';
import ContactPage from './views/pages/contact';
import PurchaseChat from './views/PurchaseChat';
// import PetQuery from './views/PetQuery';
import Subscribe from './views/Subscribe';

import ResourcesPage from './views/pages/Resources';
import ResourceSingle from './views/pages/ResourceSingle';
import VideosPage from './views/pages/Videos';
import Giving from './views/pages/Giving';

import PetsureOffer from './views/PetsureOffer';

import AdminView from './views/AdminView/AdminView';

// Uitls
import { isDev } from './utils/dev';
import { isLoggedIn } from './utils/auth';
import UserContext from './Context/UserContext';

// CSS
import 'react-datepicker/dist/react-datepicker.css';

// Google Analytics
import ReactGa from 'react-ga';
import { GA_ID } from './constants/constants';

try {
  ReactGa.initialize(GA_ID);
} catch (err) {
  console.log('Error initializing Google Analytics');
}

// Ajax Setup
window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
axios.defaults.baseURL = isDev()
  ? 'http://localhost:5443'
  : 'https://api.vetchat.com.au';

if (window.location.hostname.indexOf('uat') > -1) {
  axios.defaults.baseURL = 'https://vetassist-api-uat.vetchat.com.au';
}

let token = localStorage.getItem('token');
if (token !== null) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

const AppRouter = () => {
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());

  return (
    <Router>
      <UserContext.Provider value={{ loggedIn, setLoggedIn }}>
        <div>
          <Header />
          <div id='main-content'>
            {/* Route Outlet */}
            <Switch>
              <Route path='/' exact component={Home} />
              {/* Links to pages */}
              <Route path='/how-it-works' exact component={HowItWorksPage} />
              <Route path='/pricing' exact component={PricingPage} />
              <Route path='/about' exact component={AboutPage} />
              <Route path='/contact' exact component={ContactPage} />

              <Route path='/privacy-policy' exact component={GeneralPage} />
              <Route
                path='/terms-and-conditions'
                exact
                component={GeneralPage}
              />
              <Route path='/faq' exact component={GeneralPage} />

              <Route path='/video-purchase' component={PurchaseChat} />
              <Route path='/chat-purchase' component={PurchaseChat} />
              <Route path='/subscribe' component={Subscribe} />

              <Route path='/admin' exact component={AdminView} />
              <Route path='/admin/:view' exact component={AdminView} />
              <Route path='/signup' exact component={Signup} />
              <Route path='/login' exact component={Login} />
              <Route path='/logout' exact component={SignOff} />
              <Route path='/myaccount' exact component={MyAccount} />
              <Route path='/signoff' exact component={SignOff} />
              <Route path='/addpet' exact component={AddPet} />
              <Route
                path='/text-chat/:consultation_id'
                component={VetchatText}
              />
              <Route path='/text-chat' exact component={VetchatText} />
              <Route
                path='/video-chat/:consultation_id'
                component={VetchatVideo}
              />
              <Route path='/video-chat' exact component={VetchatVideo} />
              <Route path='/forgotpassword' exact component={ForgotPassword} />
              <Route path='/resetpwd' exact component={ResetPassword} />
              <Route path='/resetpwd/:code' component={ResetPassword} />

              {/* resoruce */}
              <Route path='/resources' exact component={ResourcesPage} />
              <Route
                path='/resource/ebook/:slug'
                exact
                component={ResourceSingle}
              />
              <Route
                path='/resource/infographic/:slug'
                exact
                component={ResourceSingle}
              />
              <Route path='/videos' exact component={VideosPage} />
              <Route path='/petsure' component={PetsureOffer} />
              <Route path='/giving' exact component={Giving} />

              <Route component={NotFound} />
            </Switch>
          </div>
          <Footer />
        </div>
      </UserContext.Provider>
    </Router>
  );
};

export default AppRouter;
